import { render, staticRenderFns } from "./base-info.vue?vue&type=template&id=1b0e1e7a"
import script from "./base-info.vue?vue&type=script&lang=ts"
export * from "./base-info.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports